import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import { MARKUP_TABLES } from '../data/Store'



const styles = theme => ({
  table: {
    marginBottom: theme.spacing.unit * 3,
  },
  tableRow: {
    height: 'inherit',
  },
  tableCell: {
    padding:  `8px 0px !important`,
  },
  highlight: {
    background: '#ff0',
  },
});



class PartMarkupForm extends React.Component {

  state = {}


  render = () => {
    const {classes, order, actions} = this.props

    const { partsMarkupOption } = order

    return (
      <div>
        <Table padding="dense" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell style={{fontSize: '100%'}} className={classes.tableCell} align="right">For parts that cost between:</TableCell>
              <TableCell style={{fontSize: '100%'}} className={classes.tableCell} colSpan={3} align="center">Mark my part up by:</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              MARKUP_TABLES[0].table.map((row, i) => (
                <TableRow key={i} className={classes.tableRow}>
                  <TableCell className={classes.tableCell} align="right">
                    <div style={{paddingRight:8}}>
                      ${parseFloat(row.min).toFixed(2)}
                      {
                        i + 1 === MARKUP_TABLES[0].table.length
                        ? ` and above`
                        : ` and ${parseFloat(row.max).toFixed(2)}`
                      }
                    </div>
                  </TableCell>
                  {
                    MARKUP_TABLES.map(m => (
                      <TableCell key={m.value} align="center" className={`${classes.tableCell} ${m.value === partsMarkupOption ? classes.highlight : ''}`}>
                        {parseFloat(m.table[i].multiplier).toFixed(2)}x
                      </TableCell>
                    ))}
                </TableRow>
              ))
            }
            <TableRow>

              <TableCell className={classes.tableCell}>
                <Button style={{visibility:"hidden"}} variant="outlined" color="primary">
                  Create Custom Markup
                </Button>
              </TableCell>
              {
                MARKUP_TABLES.map(m => (
                  <TableCell key={m.value} align="center" className={classes.tableCell}>
                    <FormControlLabel
                      value={m.value}
                      control={<Radio color="primary" />}
                      label={m.name}
                      labelPlacement="bottom"
                      checked={partsMarkupOption === m.value}
                      onChange={e => actions.setPartsMarkupOption(order, m.value)}
                    />

                  </TableCell>)
                )}
            </TableRow>
          </TableBody>
        </Table>

      </div>
    )
  }
}

PartMarkupForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(PartMarkupForm);
